
import { Injectable } from '@angular/core';
import { QuotationQuotationsResourceService } from 'libraries/service/resources/quotation-quotations/quotation-quotations-resource.service';
import { INotification } from 'libraries/interfaces/INotification';
import { Yii } from 'libraries/interfaces/Yii';
import { IQuotationsQuotation } from 'libraries/service/resources/quotation-quotations/IQuotationsQuotation';
import { finalize } from 'rxjs/operators';
import { LabelService } from 'libraries/service/label/label.service';
import { ErrorTracingService, TraceSeverity } from 'libraries/service/error-tracing/error-tracing.service';

export interface IXRateHandler {
    loading: INotification;
    errorNotification: INotification;
    quotation: IQuotationsQuotation;
    hasFoundRate: boolean;
    initQuotation(quotation: IQuotationsQuotation): void;
}

@Injectable()
export class XRateService {

    constructor(
        private readonly quotationQuotationsResourceService: QuotationQuotationsResourceService,
        private readonly labelService: LabelService,
        private readonly errorTracingService: ErrorTracingService,
    ) { }

    public refreshXRatesAndComponentState(component: IXRateHandler): void {
        component.loading = {
            active: true,
            message: Yii.t('wui-quotation-js', "Rafraîchissement des prix et taux de la cotation en cours"),
        };
        this.quotationQuotationsResourceService
            .refreshXRates(component.quotation.id)
            .pipe(
                finalize(() => {
                    component.loading.active = false;
                })
            )
            .subscribe({
                next: (quotation: IQuotationsQuotation): void => {
                    component.initQuotation(quotation);
                    if (!quotation.isXRateValid) {
                        component.hasFoundRate = false;
                    }
                },
                error: (error: Error): void => {
                    component.errorNotification = {
                        active: true,
                        message: this.labelService.completeLabel(
                            Yii.t('wui-quotation-js', 'Erreur lors du rafraîchissement des prix et taux de change de la cotation : %placeholder%'),
                            error.message,
                        ),
                    };
                    this.errorTracingService.captureMessage(error.message, TraceSeverity.Warning);
                }
            });
    }
}
